export const SCREEN_SIZES = {
    MOBILE_MAX_WIDTH: 768,
    SMALL_MAX_HEIGHT: 576,
    TABLET_MAX: 992,
    DESKTOP_MIN: 993,
};
